import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function CenteredModal({ open, onClose, title, children }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="absolute inset-0" onClick={onClose} />
      <div className="relative bg-white dark:bg-zinc-800 rounded-2xl shadow-2xl max-w-md w-full p-6 animate-fadeIn">
        <button
          className="absolute top-2 right-2 p-1 rounded-full bg-white hover:bg-gray-100 dark:bg-zinc-700 dark:hover:bg-zinc-600 text-gray-400 hover:text-gray-900 dark:text-gray-500 dark:hover:text-white shadow focus:outline-none focus:ring-2 focus:ring-blue-400"
          onClick={onClose}
          aria-label="Schließen"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
        {title && <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-4 text-center">{title}</h2>}
        {children}
      </div>
    </div>
  );
} 